import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { memo } from 'react';
import { Box } from '@mui/material';
import { StaleIndicator } from 'console/tabs/stale-indicator';
export const SmallTabs = memo(function SmallTabs(props) {
    const { pages, bannersHeight } = props;
    return (_jsxs(Box, { "data-tooltip": "device-small-tabs-container", height: "100%" //убрать -> пропадает scroll
        , sx: {
            bgcolor: 'background.default',
            color: 'text.primary',
            pb: `${bannersHeight}px`,
        }, children: [pages.map(({ visible, content, tab_name }, index) => (_jsx(Box, { "data-tooltip": `small-tab-content ${tab_name}`, height: "100%", sx: {
                    display: visible ? 'flex' : 'none',
                    position: 'relative',
                    overflow: 'auto',
                    WebkitOverflowScrolling: 'touch',
                    flexDirection: 'column',
                }, children: content }, index))), _jsx(StaleIndicator, {})] }));
});
